// Generated by `npm run data:woa-temperature` (scripts/data/woaSurfaceTemperature.ts) from data/woa23-surface-temperature/
// (the World Ocean Atlas 2023's surface temperature, 1991-2020, NOAA NCEI, public domain). Do not edit by hand.

/**
 * The Pacific's water warmer than 24 °C at the surface each month, January first, km²: the North Pacific's
 * low band's and the South Pacific's (M108), the blue marlin's.
 */
export const BLUE_MARLIN_WARM_NORTH_KM2: readonly number[] = [42234200, 40650800, 40812500, 42463400, 44878500, 48771700, 53262600, 56759100, 56679700, 53915900, 49573300, 45484600];
export const BLUE_MARLIN_WARM_SOUTH_KM2: readonly number[] = [42119500, 46706600, 46248100, 43129300, 39114700, 35219800, 30703200, 28425600, 27969200, 29158400, 31347400, 34528200];

/** The North Pacific's low band's share of it each month: the share of the stock there. */
export const BLUE_MARLIN_NORTH_SHARE: readonly number[] = [0.50068, 0.465339, 0.468783, 0.49611, 0.534311, 0.580674, 0.634337, 0.666306, 0.669586, 0.649008, 0.612615, 0.568467];
